module.exports = __webpack_public_path__ + "img/field2.29f794c4.png";